import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import { Translation } from '@ps/web-shared-components';
import classnames from 'clsx';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import type { StarsWebExtraWallet } from '@swf/core/models/sports/extraWallets/types';
import { getIsWalletBonusCash } from '@swf/core/models/sports/extraWallets/utils/getIsWallet';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';

import {
  TXTCLI_ExpiresX_N0,
  TXTWCL_N0_Bonus_Cash,
  TXTWCL_N0_Free_Bet
} from './WalletDetailTitle.messages.json';
import styles from './WalletDetailTitle.scss';

interface Props {
  wallet: StarsWebExtraWallet;
  hasVisibleDetails: boolean;
}

const WalletDetailTitle: React.FC<Props> = ({ wallet, hasVisibleDetails }) => {
  const isBonusCash = getIsWalletBonusCash(wallet);

  return (
    <button type="button" className={styles.bonusCash}>
      <span className={styles.bonusCashAmount}>
        <Translation
          {...(isBonusCash ? TXTWCL_N0_Bonus_Cash : TXTWCL_N0_Free_Bet)}
          values={{
            0: <CurrencyAmount value={wallet.amount} dollarValue currency={wallet.currency} />
          }}
        />
      </span>
      <span className={styles.bonusCashExpiry}>
        <Translation
          {...TXTCLI_ExpiresX_N0}
          values={{
            0: <FormattedDateTime date={wallet.expiry} format="long" hideTime />
          }}
        />
      </span>
      <Icon
        icon={ChevronMediumDown}
        size="x1"
        className={classnames(styles.iconChevron, {
          [styles.iconChevronOpen]: hasVisibleDetails
        })}
      />
    </button>
  );
};

export default WalletDetailTitle;
